import { Investor, InvestorSchema, parseInvestorUid } from '../models/Investor'
import { getFinder, getInserter } from 'src/util/src/zod'

export const allInvestors: Investor[] = []

export const addInvestor = getInserter<Investor>('Investor', InvestorSchema, parseInvestorUid, allInvestors)

export const findInvestor = getFinder(parseInvestorUid, allInvestors)

export const PanteraCapital = addInvestor({
  name: 'Pantera Capital',
  url: 'https://panteracapital.com/',
  type: 'Fund',
})
